// DEPENDENCIES
import React, { useEffect, useState } from 'react';
import { useFormik } from 'formik';
// COMPONENTS
// CUSTOM COMPONENTS
import LoadingScreen from '../../components/LoadingScreen';
import Section from '../../components/Section';
import ContentBlock from '../../components/ContentBlock';
import CustomBlock from '../../components/CustomBlock';
import ContentHeader from '../../components/ContentHeader';
import InputBlock from '../../components/InputBlock';
import CheckboxBlock from '../../components/CheckboxBlock';
import Button from '../../components/Button';
import FormBlock from '../../components/FormBlock';
import SelectBlock from '../../components/SelectBlock';
// SERVICES AND HELPERS
import { Alert } from '../../helpers/Alert';
import * as Helper from '../../helpers/helper';
import MediaTypeCreateValidator from '../../helpers/validators/product-management/MediaTypeCreateValidator';
import * as MediaTypeService from '../../services/mediatype.service';
import * as CompanyService from '../../services/company.service';

var timeoutId = 0

const CreateNewMediaTypePage = (props) => {
    const role = Helper.LoggedInUserRole();
    const companyId = Helper.LoggedInCompanyId();

    const { location } = props
    const urlId = location.pathname.split('/').pop();
    const [mediaTypeId, setMediaTypeId] = useState(parseInt(urlId) == urlId ? urlId : 0);
    const initialState = { id: mediaTypeId, name: "", isActive: true, companyId: companyId }

    const [loading, setLoading] = useState(false);
    const [isChecking, setIsChecking] = useState(false);
    const [isUsed, setIsUsed] = useState(false);
    const [isDisabled, setIsDisabled] = useState(role == 'User');
    const [submissionType, setSubmissionType] = useState(0);

    const [companies, setCompanies] = useState([]);
    const [selectedCompany, setSelectedCompany] = useState(companyId);

    const [mediaType, setMediaType] = useState(initialState);

    useEffect(() => {
        setLoading(true);
        if (mediaTypeId > 0)
            MediaTypeService.Get(mediaTypeId).then(res => {
                setMediaType(res);
                LoadCompanies(res.companyId);
            }).catch(ex => {
                setLoading(false);
            });
        else
            LoadCompanies(selectedCompany);
    }, [])

    const LoadCompanies = (defaultCompanyId) => {
        if (role == "SuperAdmin") {
            CompanyService.GetAll().then(res => {
                setCompanies(res);
                let companySaved = res.find(x => x.id == defaultCompanyId);
                setSelectedCompany(Helper.SetOptionModel(companySaved.businessName, companySaved.id));
                setLoading(false);
            }).catch(ex => {
                setLoading(false);
            });
        }
        else
            setLoading(false);
    }

    const checkName = (e) => {
        clearTimeout(timeoutId);
        setIsChecking(true);
        timeoutId = setTimeout(() => {
            formik.setFieldTouched('name');
            if (e != undefined && e.target.value == mediaType.name) {
                setIsUsed(false);
                setIsChecking(false);
            }
            else
                MediaTypeService.Check(e == undefined ? formik.values.name : e.target.value, selectedCompany >= 0 ? selectedCompany : selectedCompany.value).then(res => {
                    setIsUsed(res);
                    setIsChecking(false)
                });
        }, 300);
    }

    const CreateMediaType = (values, setSubmitting) => {
        if (isUsed)
            return;
        setLoading(true);
        MediaTypeService.Save(values).then(res => {
            setSubmitting(false);
            setLoading(false);
            Alert({ success: true, message: "Media Type has been saved!" });
            if (submissionType == 1)
            {
                setMediaType({ id: 0, name: "", isActive: true, companyId: companyId });
                formik.setFieldValue("name", "");
            }
            else
                props.history.push("/media-types");
        }).catch(ex => {
            setSubmitting(false);
            setLoading(false);
        });
    }

    const formik = useFormik({
        initialValues: mediaType,
        enableReinitialize: true,
        validationSchema: MediaTypeCreateValidator,
        onSubmit: (values, { setSubmitting }) => {
            CreateMediaType(values, setSubmitting);
        }
    })

    return (
        <>
            {
                loading ?
                    <LoadingScreen /> :
                    <CustomBlock className="main-container light--bg">
                        <Section>
                            <CustomBlock className="content-container--card-style">
                                <ContentHeader
                                    title={(mediaTypeId > 0 ? "Update" : "Add New") + " Media Type"}
                                    headerSize="sm"
                                />
                                <FormBlock onSubmit={formik.handleSubmit}>
                                    <Section removeContainer>
                                        {
                                            role == "SuperAdmin" ?
                                                <ContentBlock>
                                                    <SelectBlock
                                                        id="companyId"
                                                        name="companyId"
                                                        inputLabel="Company"
                                                        bordered
                                                        value={selectedCompany}
                                                        options={companies.map(x => Helper.SetOptionModel(x.businessName, x.id))}
                                                        onBlur={() => formik.setFieldTouched("companyId")}
                                                        onChange={option => {
                                                            option = option === null ? [] : option;
                                                            setSelectedCompany(option);
                                                            formik.setFieldValue("companyId", option.value);
                                                        }}
                                                        inputState={
                                                            formik.touched.companyId && formik.errors.companyId
                                                                ? "error"
                                                                : formik.touched.companyId && formik.errors.companyId == null
                                                                    ? "success"
                                                                    : ""
                                                        }
                                                        errorMessage={formik.errors.companyId}
                                                    />
                                                </ContentBlock> : <></>
                                        }
                                        <ContentBlock>
                                            <InputBlock
                                                id="name"
                                                inputLabel="Media Type Name"
                                                bordered
                                                {...formik.getFieldProps("name")}
                                                inputState={
                                                    selectedCompany == 0 ? "disabled" :
                                                        formik.touched.name && (formik.errors.name || isUsed)
                                                            ? "error"
                                                            : formik.touched.name && formik.errors.name == null && !isUsed ? "success" : ""
                                                }
                                                errorMessage={isUsed ? "Name is already in use!" : formik.errors.name}
                                                onKeyUp={checkName}
                                                loading={isChecking}
                                                disabled={isDisabled}
                                            />
                                        </ContentBlock>

                                        <ContentBlock className="padding-vertical--min">
                                            <CheckboxBlock
                                                label="Is media type active?"
                                                id="is-active-checkbox"
                                                defaultChecked={formik.values.isActive}
                                                {...formik.getFieldProps("isActive")}
                                                disabled={isDisabled}
                                            />
                                        </ContentBlock>

                                        <CustomBlock className="content-container--actions">
                                            <Button
                                                to="/media-types"
                                                text="Cancel"
                                                className="danger--bg fit-content"
                                            />
                                            {
                                                role == 'User' ? <></> :
                                                    <>
                                                        {
                                                            mediaTypeId > 0 ?
                                                                <Button
                                                                    text="Save"
                                                                    type="submit"
                                                                    className="success--bg fit-content"
                                                                /> :
                                                                <>
                                                                    <Button
                                                                        text="Save and Clear"
                                                                        type="submit"
                                                                        className="success--bg fit-content"
                                                                        onClick={() => setSubmissionType(1)}
                                                                    />
                                                                    <Button
                                                                        text="Save and Exit"
                                                                        type="submit"
                                                                        className="success--bg fit-content"
                                                                        onClick={() => setSubmissionType(2)}
                                                                    />
                                                                </>
                                                        }
                                                    </>
                                            }

                                        </CustomBlock>
                                    </Section>
                                </FormBlock>
                            </CustomBlock>
                        </Section>
                    </CustomBlock>
            }

        </>
    );
}

export default CreateNewMediaTypePage;